import Logger from '../logger';

/* eslint-disable @typescript-eslint/no-explicit-any */

// log-errors.decorator.ts
export function LogErrors(): MethodDecorator {
  return (
    target: object,
    propertyKey: string | symbol,
    descriptor: PropertyDescriptor,
  ): PropertyDescriptor | void => {
    const originalMethod = descriptor.value as (...args: any[]) => any;

    if (typeof originalMethod !== 'function') {
      throw new Error(`@LogErrors can only be applied to methods.`);
    }

    const wrappedMethod = function <T extends (...args: any[]) => any>(
      this: ThisParameterType<T>,
      ...args: Parameters<T>
    ): ReturnType<T> {
      try {
        const result = originalMethod.apply(this, args);

        if (result instanceof Promise) {
          return result.catch((err: unknown) => {
            const className = target.constructor?.name ?? 'UnknownClass';
            const methodName = String(propertyKey);
            Logger.error(`${className}.${methodName} failed:`, err);
            throw err;
          }) as ReturnType<T>;
        }

        return result;
      } catch (err) {
        const className = target.constructor?.name ?? 'UnknownClass';
        const methodName = String(propertyKey);
        Logger.error(`${className}.${methodName} failed:`, err);
        throw err;
      }
    };

    descriptor.value = wrappedMethod;
    return descriptor;
  };
}
